import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import {
  ALLOWED_MIN_AGE,
  DAILY_PENALTY_RATE,
  GESV_RATE_MAX,
  GRACE_PERIOD_DAYS,
  LOAN_AMOUNT_MAX_VALUE,
  LOAN_PERIOD_MAX_VALUE,
  LOAN_PERIOD_MIN_VALUE,
} from '@/common/constants/loan';
import { formatAmount } from '@/common/utils/formatNumber';

const SeoText = () => (
  <section className="section">
    <div className={cn('container', styles.textBlock)}>
      <p>
        <FormattedMessage
          defaultMessage="Вы столкнулись с ситуацией, когда понадобились финансы, но одолжить не
        у кого? Оплачиваете кредиты и нуждаетесь в дополнительных денежных
        средствах для их погашения?"
        />
        <br />
        <FormattedMessage
          defaultMessage="
        Оказались в безвыходном положении, когда деньги нужны здесь и сейчас?
        Мы предоставляем Вам возможность получить нужную сумму уже сегодня, не
        выходя из дома!"
        />
        <br />
        <FormattedMessage
          defaultMessage="Микрокредиты от онлайн сервиса NeoCredit — это надежный способ решения
        материальной проблемы в кратчайший срок для каждого гражданина
        Казахстана. Мы гарантируем экономию Вашего времени и нервов, так как
        процесс одобрения происходит онлайн и занимает всего 10 минут —
        необходимо лишь заполнить анкету на сайте."
        />
        <br />
        <FormattedMessage
          defaultMessage="Вы с нами впервые? — мы готовы предоставить такие же выгодные условия,
        как для опытных партнеров-заемщиков. Первые {value} дней — без процентов!"
          values={{ value: GRACE_PERIOD_DAYS }}
        />
      </p>
      <p>
        <span className="font-bold">
          <FormattedMessage defaultMessage="Условия кредитования" />:<br />
        </span>
        -{' '}
        <FormattedMessage
          defaultMessage="Мы предоставляем микрокредиты физлицам от {value} года"
          values={{ value: ALLOWED_MIN_AGE }}
        />
        <br />-{' '}
        <FormattedMessage
          defaultMessage="Сумма микрокредитования: до {value} тенге"
          values={{ value: formatAmount(LOAN_AMOUNT_MAX_VALUE) }}
        />
        <br />-{' '}
        <FormattedMessage
          defaultMessage="Минимальный срок {minValue} дней, максимальный {maxValue} дней"
          values={{
            minValue: LOAN_PERIOD_MIN_VALUE,
            maxValue: LOAN_PERIOD_MAX_VALUE,
          }}
        />
        <br />-{' '}
        <FormattedMessage
          defaultMessage="Ставка по микрокредиту – до {penalty} в день"
          values={{ penalty: DAILY_PENALTY_RATE }}
        />
        <br />-{' '}
        <FormattedMessage
          defaultMessage="ГЭСВ при оформлении микрокредита в сумме не превышающей 45-ти кратный размер месячного расчетного показателя, — до {gesvRate} в зависимости от суммы и срока микрокредита"
          values={{ gesvRate: GESV_RATE_MAX }}
        />
        <br />-{' '}
        <FormattedMessage defaultMessage="Комиссия за досрочное и частичное погашение отсутствует" />
        <br />-{' '}
        <FormattedMessage
          defaultMessage="В случае, если сумма микрокредита не будет выплачена в указанный срок, кредитор может требовать неустойку от общей суммы просроченного платежа за каждый день просрочки не более {penalty} от суммы основного долга"
          values={{
            penalty: DAILY_PENALTY_RATE,
          }}
        />
      </p>
      <p>
        <span className="font-bold">
          <FormattedMessage defaultMessage="Пример расчета" />
        </span>
        <br />
        <FormattedMessage defaultMessage="Сумма основного долга: 60 000 тг" />
        <br />
        <FormattedMessage defaultMessage="Ежедневное вознаграждение: до 0,3% в день" />
        <br />
        <FormattedMessage defaultMessage="Срок микрокредита: 61 день" />
        <br />
        <FormattedMessage defaultMessage="Сумма вознаграждения: 10 980 тг" />
        <br />
        <FormattedMessage defaultMessage="К возврату: 70 980 тг" />
        <br />
        <FormattedMessage defaultMessage="Годовая эффективная ставка вознаграждения: 173,35%" />
        <br />
      </p>
    </div>
  </section>
);

export default SeoText;
